export function convertFactToSelectOptions<Facts extends Record<string, unknown>>(facts: Facts) {
  return Object.entries(facts).map(([key, value]) => ({
    value: value as Facts[keyof Facts],
    label: key
      .replace(/_/g, " ")
      .toLowerCase()
      .replace(/\b(\w)/g, char => char.toUpperCase()),
  }));
}
